import { api } from '@/fsd/shared/api';
import { Organization } from '../model/types/types';

export const getUsersOrganizations = async (): Promise<Organization[]> => {
  const data = await api.get<{ data: Organization[] }>(`/api/v1/organisation/`);

  return data.data;
};
